module.exports = __webpack_public_path__ + "img/white-checkmark.0c4d10d4.svg";